if not App.angularApp?
    return

App.angularApp.directive 'mfErrorsContainer', () ->
    return {
        restrict: 'E'
        link: (scope, element, attrs, ctrl) =>
            element.addClass 'errorDiv'
            element.show()
        controller: () =>
            undefined
    }
